import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateDetailsForTemplateEditorFragment = { __typename: 'Template', id: string, legacyId: number, organization: { __typename: 'Organization', id: string }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null };

export type GetTemplateDetailsForTemplateEditorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetTemplateDetailsForTemplateEditorQuery = { __typename: 'Query', template: { __typename: 'Template', id: string, legacyId: number, organization: { __typename: 'Organization', id: string }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null } };

export type PictureDetailsForTemplateEditorFragment = { __typename: 'Picture', id: string, legacyId: number, template?: { __typename: 'Template', id: string, legacyId: number, organization: { __typename: 'Organization', id: string }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null } | null, organization: { __typename: 'Organization', id: string } };

export type GetPictureDetailsForTemplateEditorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetPictureDetailsForTemplateEditorQuery = { __typename: 'Query', picture: { __typename: 'Picture', id: string, legacyId: number, template?: { __typename: 'Template', id: string, legacyId: number, organization: { __typename: 'Organization', id: string }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null } | null, organization: { __typename: 'Organization', id: string } } };

export type TemplateRevisionDetailsForTemplateEditorFragment = { __typename: 'TemplateRevision', id: string, legacyId: number, graph?: any | null, inconsistencies: Array<any>, number: number, template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, type: Types.TemplateType, organization: { __typename: 'Organization', id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null, picture?: { __typename: 'Picture', id: string, name: string, number: number, state: Types.PictureState, organization: { __typename: 'Organization', id: string } } | null } | null };

export type GetTemplateRevisionDetailsForTemplateEditorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetTemplateRevisionDetailsForTemplateEditorQuery = { __typename: 'Query', templateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number, graph?: any | null, inconsistencies: Array<any>, number: number, template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, type: Types.TemplateType, organization: { __typename: 'Organization', id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null, picture?: { __typename: 'Picture', id: string, name: string, number: number, state: Types.PictureState, organization: { __typename: 'Organization', id: string } } | null } | null } };

export type GetLatestTemplateRevisionDetailsForTemplateEditorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetLatestTemplateRevisionDetailsForTemplateEditorQuery = { __typename: 'Query', templateRevision: { __typename: 'TemplateRevision', template?: { __typename: 'Template', id: string, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, graph?: any | null, inconsistencies: Array<any>, number: number, template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, type: Types.TemplateType, organization: { __typename: 'Organization', id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null, picture?: { __typename: 'Picture', id: string, name: string, number: number, state: Types.PictureState, organization: { __typename: 'Organization', id: string } } | null } | null } | null } | null } };

export type GetTemplateRevisionsDetailsForTemplateEditorQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TemplateRevisionFilterInput>;
}>;


export type GetTemplateRevisionsDetailsForTemplateEditorQuery = { __typename: 'Query', templateRevisions: Array<{ __typename: 'TemplateRevision', id: string, legacyId: number, graph?: any | null, inconsistencies: Array<any>, number: number, template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, type: Types.TemplateType, organization: { __typename: 'Organization', id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null, picture?: { __typename: 'Picture', id: string, name: string, number: number, state: Types.PictureState, organization: { __typename: 'Organization', id: string } } | null } | null } | null> };

export type CreateTemplateRevisionForTemplateEditorMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateRevisionInput;
}>;


export type CreateTemplateRevisionForTemplateEditorMutation = { __typename: 'Mutation', createTemplateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number, graph?: any | null, inconsistencies: Array<any>, number: number, template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, type: Types.TemplateType, organization: { __typename: 'Organization', id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null, picture?: { __typename: 'Picture', id: string, name: string, number: number, state: Types.PictureState, organization: { __typename: 'Organization', id: string } } | null } | null } };

export type CreateTemplateForTemplateEditorMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateInput;
}>;


export type CreateTemplateForTemplateEditorMutation = { __typename: 'Mutation', createTemplate: { __typename: 'Template', id: string, legacyId: number, organization: { __typename: 'Organization', id: string }, latestRevision?: { __typename: 'TemplateRevision', id: string, number: number } | null } };

export type UpdateTemplateRevisionForTemplateEditorMutationVariables = Types.Exact<{
  input: Types.MutationUpdateTemplateRevisionInput;
}>;


export type UpdateTemplateRevisionForTemplateEditorMutation = { __typename: 'Mutation', updateTemplateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number } };

export type UpdateTemplateForTemplateEditorMutationVariables = Types.Exact<{
  input: Types.MutationUpdateTemplateInput;
}>;


export type UpdateTemplateForTemplateEditorMutation = { __typename: 'Mutation', updateTemplate: { __typename: 'Template', id: string, legacyId: number } };

export type UpdatePictureForTemplateEditorMutationVariables = Types.Exact<{
  input: Types.MutationUpdatePictureInput;
}>;


export type UpdatePictureForTemplateEditorMutation = { __typename: 'Mutation', updatePicture: { __typename: 'Picture', id: string, legacyId: number } };

export const TemplateDetailsForTemplateEditorFragmentDoc = gql`
    fragment TemplateDetailsForTemplateEditor on Template {
  id
  legacyId
  organization {
    id
  }
  latestRevision {
    id
    number
  }
}
    `;
export const PictureDetailsForTemplateEditorFragmentDoc = gql`
    fragment PictureDetailsForTemplateEditor on Picture {
  id
  legacyId
  template {
    ...TemplateDetailsForTemplateEditor
  }
  organization {
    id
  }
}
    `;
export const TemplateRevisionDetailsForTemplateEditorFragmentDoc = gql`
    fragment TemplateRevisionDetailsForTemplateEditor on TemplateRevision {
  id
  legacyId
  graph
  inconsistencies
  number
  template {
    id
    legacyId
    name
    type
    organization {
      id
      legacyId
    }
    latestRevision {
      id
      number
    }
    picture {
      id
      name
      number
      organization {
        id
      }
      state
    }
  }
}
    `;
export const GetTemplateDetailsForTemplateEditorDocument = gql`
    query getTemplateDetailsForTemplateEditor($id: ID!) {
  template(id: $id) {
    ...TemplateDetailsForTemplateEditor
  }
}
    ${TemplateDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateDetailsForTemplateEditorGQL extends Apollo.Query<GetTemplateDetailsForTemplateEditorQuery, GetTemplateDetailsForTemplateEditorQueryVariables> {
    override document = GetTemplateDetailsForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPictureDetailsForTemplateEditorDocument = gql`
    query getPictureDetailsForTemplateEditor($id: ID!) {
  picture(id: $id) {
    ...PictureDetailsForTemplateEditor
  }
}
    ${PictureDetailsForTemplateEditorFragmentDoc}
${TemplateDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPictureDetailsForTemplateEditorGQL extends Apollo.Query<GetPictureDetailsForTemplateEditorQuery, GetPictureDetailsForTemplateEditorQueryVariables> {
    override document = GetPictureDetailsForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateRevisionDetailsForTemplateEditorDocument = gql`
    query getTemplateRevisionDetailsForTemplateEditor($id: ID!) {
  templateRevision(id: $id) {
    ...TemplateRevisionDetailsForTemplateEditor
  }
}
    ${TemplateRevisionDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateRevisionDetailsForTemplateEditorGQL extends Apollo.Query<GetTemplateRevisionDetailsForTemplateEditorQuery, GetTemplateRevisionDetailsForTemplateEditorQueryVariables> {
    override document = GetTemplateRevisionDetailsForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLatestTemplateRevisionDetailsForTemplateEditorDocument = gql`
    query getLatestTemplateRevisionDetailsForTemplateEditor($id: ID!) {
  templateRevision(id: $id) {
    template {
      id
      latestRevision {
        ...TemplateRevisionDetailsForTemplateEditor
      }
    }
  }
}
    ${TemplateRevisionDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLatestTemplateRevisionDetailsForTemplateEditorGQL extends Apollo.Query<GetLatestTemplateRevisionDetailsForTemplateEditorQuery, GetLatestTemplateRevisionDetailsForTemplateEditorQueryVariables> {
    override document = GetLatestTemplateRevisionDetailsForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateRevisionsDetailsForTemplateEditorDocument = gql`
    query getTemplateRevisionsDetailsForTemplateEditor($filter: TemplateRevisionFilterInput) {
  templateRevisions(filter: $filter) {
    ...TemplateRevisionDetailsForTemplateEditor
  }
}
    ${TemplateRevisionDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateRevisionsDetailsForTemplateEditorGQL extends Apollo.Query<GetTemplateRevisionsDetailsForTemplateEditorQuery, GetTemplateRevisionsDetailsForTemplateEditorQueryVariables> {
    override document = GetTemplateRevisionsDetailsForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateRevisionForTemplateEditorDocument = gql`
    mutation createTemplateRevisionForTemplateEditor($input: MutationCreateTemplateRevisionInput!) {
  createTemplateRevision(input: $input) {
    ...TemplateRevisionDetailsForTemplateEditor
  }
}
    ${TemplateRevisionDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateRevisionForTemplateEditorGQL extends Apollo.Mutation<CreateTemplateRevisionForTemplateEditorMutation, CreateTemplateRevisionForTemplateEditorMutationVariables> {
    override document = CreateTemplateRevisionForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateForTemplateEditorDocument = gql`
    mutation createTemplateForTemplateEditor($input: MutationCreateTemplateInput!) {
  createTemplate(input: $input) {
    ...TemplateDetailsForTemplateEditor
  }
}
    ${TemplateDetailsForTemplateEditorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateForTemplateEditorGQL extends Apollo.Mutation<CreateTemplateForTemplateEditorMutation, CreateTemplateForTemplateEditorMutationVariables> {
    override document = CreateTemplateForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateRevisionForTemplateEditorDocument = gql`
    mutation updateTemplateRevisionForTemplateEditor($input: MutationUpdateTemplateRevisionInput!) {
  updateTemplateRevision(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateRevisionForTemplateEditorGQL extends Apollo.Mutation<UpdateTemplateRevisionForTemplateEditorMutation, UpdateTemplateRevisionForTemplateEditorMutationVariables> {
    override document = UpdateTemplateRevisionForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateForTemplateEditorDocument = gql`
    mutation updateTemplateForTemplateEditor($input: MutationUpdateTemplateInput!) {
  updateTemplate(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateForTemplateEditorGQL extends Apollo.Mutation<UpdateTemplateForTemplateEditorMutation, UpdateTemplateForTemplateEditorMutationVariables> {
    override document = UpdateTemplateForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePictureForTemplateEditorDocument = gql`
    mutation updatePictureForTemplateEditor($input: MutationUpdatePictureInput!) {
  updatePicture(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePictureForTemplateEditorGQL extends Apollo.Mutation<UpdatePictureForTemplateEditorMutation, UpdatePictureForTemplateEditorMutationVariables> {
    override document = UpdatePictureForTemplateEditorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }